import RichTextEditor from 'react-rte';

export default {
  name: {
    label: 'Name',
    placeholder: 'Add name',
    system: {
      name: 'name',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'name',
    rules: {
      title: 'Name field',
      required: true,
    }
  },
  content: {
    label: 'Content',
    placeholder: 'Add content',
    system: {
      name: 'content',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'content',
    rules: {
      title: 'Content field',
      required: true,
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/EmailTemplatesEdit/fields.js